import { API_BASE_URL } from "../config/environment";

/**
 * Get list of uploaded competition files
 */
export const getUploadedFiles = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/uploaded-files`);
    if (!response.ok) {
      throw new Error("Failed to fetch uploaded files");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching uploaded files:", error);
    throw error;
  }
};

/**
 * Format file size for display
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

/**
 * Format date for display
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
